/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { selectConfigLogo } from '@containers/Home/selectors';
import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  isWrapImg?: boolean;
}

const Logo = memo(({ isWrapImg }: Props) => {
  const configLogo = useSelector(selectConfigLogo);

  const onClickLogo = useCallback(() => {
    (window as any).open(configLogo?.url, '_blank');
  }, [configLogo]);

  return (
    !!configLogo?.isEnabled &&
    !!configLogo?.image && (
      <div className={`--logo ${configLogo?.position || 'topLeft'}`}>
        {isWrapImg ? (
          <div className="--wrapper">
            <img
              src={configLogo?.image}
              alt="logo"
              onClick={onClickLogo}
              style={{ width: `${configLogo?.size || 180}px` }}
            />
          </div>
        ) : (
          <img
            src={configLogo?.image}
            alt="logo"
            onClick={onClickLogo}
            style={{ width: `${configLogo?.size || 180}px` }}
          />
        )}
      </div>
    )
  );
});

export default Logo;
